module.exports = __webpack_public_path__ + "static/media/bathroom-3563272_1920.096be110.jpg";